
import { Link } from 'react-router-dom';

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const footerSections = [
    { title: 'Platform', links: [{ name: 'About 254Tracks', href: '/about' }] },
    { title: 'Support', links: [{ name: 'Contact Support', href: 'mailto:help@254tracks.com' }] },
  ];

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Brand Section */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <img
                src="/images/254trackslogo2.png"
                alt="254Tracks"
                className="h-16 w-auto object-contain"
              />
            </Link>
            <p className="text-gray-400 text-sm mb-6">
              Kenyan Hip Hop, Direct to You. Supporting artists with direct revenue to fund more music.
            </p>
          </div>

          {/* Footer Links */}
          {footerSections.map((section) => (
            <div key={section.title}>
              <h3 className="text-white font-semibold mb-4">{section.title}</h3>
              <ul className="space-y-3">
                {section.links.map((link) => (
                  <li key={link.name}>
                    {link.href.startsWith('mailto:') ? (
                      <a
                        href={link.href}
                        className="text-gray-400 hover:text-white transition-colors text-sm"
                      >
                        {link.name}
                      </a>
                    ) : (
                      <Link
                        to={link.href}
                        className="text-gray-400 hover:text-white transition-colors text-sm"
                      >
                        {link.name}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      
      {/* Bottom Footer */}
      <div className="border-t border-gray-800 px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="flex items-center space-x-6 text-sm text-gray-400">
            <span>© {currentYear} 254Tracks. All rights reserved.</span>
          </div>
          <div className="flex items-center space-x-4 text-sm text-gray-400">
            <span>🇰🇪 Made in Kenya</span>
            <span>🎵 Pan-African Pride</span>
            <span>📧 help@254tracks.com</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
